import { generateArray, generateSentence } from '../../../utils/generate'
import { BuildingGroupMultiValuedList } from '../../BuildingGroup'
import {
  MultiValuedListSize,
  MultiValuedListVariant,
} from '../../MultiValuedList'
import { TextMultiValuedList } from '../../TextMultiValuedList'
import { UserMultiValuedList } from '../../User'
import { Container } from '../Container'

import * as styles from './MultiValuedLists.module.css'

function TextMultiValuedLists({ variant }) {
  const items = generateArray(15, () => ({
    children: generateSentence(5, 6),
  }))

  const style = { maxWidth: 200 }
  const oneItem = items.slice(0, 1)

  return Object.values(MultiValuedListSize).map(size => (
    <Container
      key={size}
      label={`Texts list, size: ${size}, variant: ${variant ?? '<unset>'}`}
    >
      <div className={styles.content}>
        <div className={styles.item}>
          <div className={styles.itemContent}>
            <TextMultiValuedList
              items={oneItem}
              size={size}
              style={style}
              variant={variant}
            />
          </div>
        </div>
        <div className={styles.item}>
          with counter:
          <div className={styles.itemContent}>
            <TextMultiValuedList
              items={oneItem}
              itemsCount={items.length}
              size={size}
              style={style}
              variant={variant}
            />
          </div>
        </div>
        <div className={styles.item}>
          with dropdown:
          <div className={styles.itemContent}>
            <TextMultiValuedList
              items={items}
              size={size}
              style={style}
              variant={variant}
            />
          </div>
        </div>
      </div>
    </Container>
  ))
}

function BuildingGroupMultiValuedLists({ variant }) {
  const items = generateArray(15, () => ({
    children: generateSentence(5, 6),
  }))

  return (
    <Container label={`Building groups list, variant: ${variant ?? '<unset>'}`}>
      <div className={styles.content}>
        <div className={styles.item}>
          <div className={styles.itemContent}>
            <BuildingGroupMultiValuedList items={items} variant={variant} />
          </div>
        </div>
      </div>
    </Container>
  )
}

function UserMultiValuedLists({ variant }) {
  const items = [
    {
      user: {
        avatarColor: 'red',
        fullname: 'Yuri Gagarin',
        key: 1,
      },
    },
    {
      user: {
        avatarColor: 'orange',
        fullname: 'Gherman Titov',
        key: 2,
      },
    },
    {
      user: {
        avatarColor: 'blue',
        fullname: 'Neil Armstrong',
        key: 3,
      },
    },
    {
      user: {
        avatarColor: 'green',
        fullname: 'Buzz Aldrin',
        key: 4,
      },
    },
    { user: { avatarColor: 'pink', fullname: 'Michael Collins', key: 5 } },
  ]

  return (
    <Container label={`Users list, variant: ${variant ?? '<unset>'}`}>
      <div className={styles.content}>
        <div className={styles.item}>
          <div className={styles.itemContent}>
            <UserMultiValuedList items={items} variant={variant} />
          </div>
        </div>
      </div>
    </Container>
  )
}

function MultiValuedLists() {
  return (
    <>
      <TextMultiValuedLists />
      <TextMultiValuedLists variant={MultiValuedListVariant.Tag} />
      <BuildingGroupMultiValuedLists />
      <BuildingGroupMultiValuedLists variant={MultiValuedListVariant.Tag} />
      <UserMultiValuedLists />
      <UserMultiValuedLists variant={MultiValuedListVariant.Tag} />
    </>
  )
}

export default MultiValuedLists
